import { render, staticRenderFns } from "./transmit.vue?vue&type=template&id=2f876d5f&"
import script from "./transmit.vue?vue&type=script&lang=js&"
export * from "./transmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports